/* eslint-disable react/no-unused-prop-types */
import React, { type CSSProperties } from 'react'
import { GridStyled, GridCellStyled, GridCellInnerStyled, GridRowStyled } from './Grid.styles'

export type GridProps = {
  padding?: CSSProperties['padding']
  margin?: CSSProperties['margin']
  children?: React.ReactNode
  maxWidth?: CSSProperties['maxWidth']
}

export type GridCellProps = {
  width?: CSSProperties['width']
  padding?: CSSProperties['padding']
  minWidth?: CSSProperties['minWidth']
  flexGrow?: CSSProperties['flexGrow']
  flexBasis?: CSSProperties['flexBasis']
  valign?: 'top' | 'middle' | 'bottom'
  align?: 'left' | 'right' | 'center'
  children?: React.ReactNode
  onClick?: () => void
}

function passPropsToChildren(props: GridProps) {
  const propsToPass = { ...props }
  delete propsToPass.children
  return React.Children.map(props.children, child => {
    if (child) {
      return React.cloneElement(child as React.ReactElement, { ...propsToPass })
    } else {
      return child
    }
  })
}

export const Grid = (props: GridProps): JSX.Element => {
  const children = passPropsToChildren(props)
  return <GridStyled {...props}>{children}</GridStyled>
}

export const GridRow = (props: GridProps): JSX.Element => {
  const children = passPropsToChildren(props)
  return <GridRowStyled>{children}</GridRowStyled>
}

export const GridCell = ({ children, ...props }: GridCellProps): JSX.Element => {
  return (
    <GridCellStyled {...props}>
      <GridCellInnerStyled {...props}>{children}</GridCellInnerStyled>
    </GridCellStyled>
  )
}
